<template>
  <div class="local-searcher-clinical">
    <div>
      <div
        class="search-box float-component px-3"
        :class="{'bar-width': !searchOptionSelected.id || searchOptionSelected.id !== PATIENT_IDENTIFIER}"
      >
        <b-row class="h-100">
          <b-col class="pr-0 h-100">
            <b-row
              class="h-100"
              :class="{'w-100':searchOptionSelected.id && searchOptionSelected.id === PATIENT_IDENTIFIER}"
            >
              <b-col
                cols="auto"
                class="px-0"
              >
                <div class="search-selector d-flex align-items-center justify-content-around">
                  <vt-combo-select
                    v-model="searchOptionSelected"
                    qa="searcher-module-identifier-options-select"
                    class="multiselect--small mb-0"
                    :allow-empty="false"
                    :searchable="false"
                    :options="identifierOptions"
                    :option-height="20"
                    :show-labels="false"
                    track-by="text"
                    label="text"
                    @select="$refs.searchBarInput.focus()"
                  >
                    <template #singleLabel="{ option }">
                      <i
                        class="main"
                        :class="option.icon"
                        aria-hidden="true"
                      />
                    </template>
                  </vt-combo-select>
                </div>
              </b-col>
              <b-col
                v-if="searchOptionSelected.id && searchOptionSelected.id === PATIENT_IDENTIFIER"
                class="px-0"
              >
                <b-row class="w-100 mx-0">
                  <b-col
                    class="px-1 d-flex align-items-center id-column"
                    cols="auto"
                  >
                    <div class="select-section identifiers">
                      <vt-combo-select
                        v-model="patientOptionSelected"
                        qa="searcher-module-patient-identifier-options-select"
                        placeholder="ID"
                        class="id-model-select nowrap"
                        track-by="code"
                        :options="patientIdentidierOptions"
                        label="name"
                        :allow-empty="false"
                        @select="$refs.searchBarInput.focus()"
                      />
                    </div>
                  </b-col>
                  <b-col
                    v-if="patientOptionSelected && patientOptionSelected.code === 'identifierType.NHC'"
                    class="px-1 d-flex align-items-center center-column"
                    md
                    sm="5"
                  >
                    <div class="select-section">
                      <vt-combo-select
                        v-model="centerSelected"
                        class="nowrap center-selection"
                        track-by="code"
                        qa="searcher-module-center-select"
                        :options="centers"
                        label="name"
                        :placeholder="$t('global.center')"
                        :allow-empty="false"
                      />
                    </div>
                  </b-col>
                  <b-col
                    md
                    sm
                    class="px-1"
                    :class="{'col-sm-5': patientOptionSelected && patientOptionSelected.code === 'identifierType.NHC'}"
                  >
                    <div class="input-section">
                      <vt-input
                        id="searchBarInput"
                        ref="searchBarInput"
                        v-model="identifierSearch"
                        v-focus
                        qa="searcher-module-identifier-input"
                        type="text"
                        :placeholder="$tc('global.identifier', 1)"
                        size="sm"
                        name="identifier"
                        @focus.native="$event.target.select()"
                        @input="clearState"
                        @enter="searchEvent"
                      />
                    </div>
                  </b-col>
                  <b-col
                    v-if="searchPatientWithName"
                    class="px-1"
                  >
                    <div class="input-section">
                      <vt-input
                        v-model="patientSurname1Search"
                        qa="searcher-module-patient-surname1"
                        type="text"
                        name="patientSurname1"
                        :placeholder="$t('global.surname1')"
                        size="sm"
                        @enter="searchEvent"
                      />
                    </div>
                  </b-col>
                  <b-col
                    v-if="globalParameters && globalParameters.secondSurnameSupported && searchPatientWithName"
                    class="px-1"
                  >
                    <div class="input-section">
                      <vt-input
                        v-model="patientSurmname2Search"
                        qa="searcher-module-patient-surname2"
                        type="text"
                        name="patientSurname2"
                        :placeholder="$t('global.surname2')"
                        size="sm"
                        @enter="searchEvent"
                      />
                    </div>
                  </b-col>
                  <b-col
                    v-if="searchPatientWithName"
                    class="px-1"
                  >
                    <div class="input-section">
                      <vt-input
                        v-model="patientNameSearch"
                        type="text"
                        qa="searcher-module-patient-name"
                        name="patientName"
                        :placeholder="$tc('global.name', 1)"
                        size="sm"
                        @enter="searchEvent"
                      />
                    </div>
                  </b-col>
                  <b-col
                    v-if="globalParameters && globalParameters.middleNameSupported && searchPatientWithName"
                    class="px-1"
                  >
                    <div class="input-section">
                      <vt-input
                        v-model="patientMiddlenameSearch"
                        qa="searcher-module-patient-middlename"
                        type="text"
                        name="patientMiddleName"
                        :placeholder="$t('global.middleName')"
                        size="sm"
                        @enter="searchEvent"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-else
                cols="auto"
                class="px-0 d-flex align-items-center"
              >
                <div class="px-2 ml-1">
                  <i
                    class="fal fa-barcode-alt"
                    aria-hidden="true"
                  />
                </div>
                <div class="general-search">
                  <vt-input
                    id="searchBarInput"
                    ref="searchBarInput"
                    v-model="identifierSearch"
                    v-focus
                    qa="searcher-module-barcode-input"
                    type="text"
                    :placeholder="$t('global.enterIdentifier')"
                    size="sm"
                    name="generalSearchIdentifier"
                    @focus.native="$event.target.select()"
                    @input="clearState"
                    @enter="searchEvent"
                  />
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            class="text-center icon-column px-1 d-flex align-items-center justify-content-end"
            cols="auto"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                v-if="searched"
                qa="searcher-module-clear-button"
                class="btn__icon btn__icon--primary  alt-btn px-1 py-0"
                @click="clearSearch"
              >
                <i
                  class="far fa-times"
                  aria-hidden="true"
                />
              </b-button>
              <b-button
                qa="searcher-module-search-button"
                class="btn__icon btn__icon--primary px-2 py-0"
                @click="searchEvent"
              >
                <i
                  class="fas fa-search"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { PATIENT_IDENTIFIER_CODES } from '@/api/resources/IdentifierRegexesService'
import { IDENTIFIER_SCOPES, INSURANCE_NUMBER, PATIENT_IDENTIFIER } from '@/api/resources/identifierScopesResource'
import { StoreUtils } from '@/shared/util/store-utils'
import PatientIdentifierResource from '@/api/resources/PatientIdentifierResource'
import CenterResource from '@/api/resources/common/commonCenterService'

export default {
    name: 'SearcherModuleEntitySelection',
    props: {
        identifierOptions: { type: Array, required: true },
        initialIdentifier: { type: Object, required: true },
        searchPatientWithName: { type: Boolean, default: true }
    },
    data() {
        return {
            centers: [],
            optionsIdentifiers: [
                { value: 'a', text: 'NHC' },
                { value: 'b', text: 'NIF' }
            ],
            selectedIdentifiers: null,
            selected: null,
            PATIENT_IDENTIFIER: PATIENT_IDENTIFIER,
            IDENTIFIER_SCOPES: IDENTIFIER_SCOPES,
            searchOptionSelected: {},
            patientOptionSelected: null,
            identifierSearch: '',
            patientNameSearch: '',
            patientMiddlenameSearch: '',
            patientSurname1Search: '',
            patientSurmname2Search: '',
            searched: false,
            patientIdentidierOptions: [],
            centerSelected: null
        }
    },
    computed: {
        regex() {
            if (this.searchOptionSelected) {
                return this.$store.getters.regex.filter((regex) => this.searchOptionSelected.scopes.includes(regex.identifierType.idtScope))
            }
            return this.$store.getters.regex
        }
    },
    async mounted() {
        let searchState = this.$store.getters.searchState
        if (searchState) {
            searchState.searchOptionSelected = searchState.searchOptionSelected ? searchState.searchOptionSelected : this.initialIdentifier
            Object.assign(this.$data, searchState)
        } else {
            this.searchOptionSelected = this.initialIdentifier
            await Promise.all([
                this.getIdentifiers(!searchState),
                this.getCenters(!searchState)
            ])
        }
        this.$eventHub.$on('focus-searcherModule', this.focusInput)
    },
    beforeDestroy() {
        this.$eventHub.$off('focus-searcherModule', this.focusInput)
    },
    methods: {
        async getIdentifiers(selectIdentifier) {
            const [err, response] = await this.toCall(PatientIdentifierResource.index())
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.patientIdentidierOptions = response
            if (selectIdentifier) {
                this.patientOptionSelected = this.patientIdentidierOptions.find(
                    (identifier) => identifier.code === this.globalParameters?.mainPatientIdentifierType.code)
            }
        },
        async getCenters(selectCenter) {
            const [err, response] = await this.toCall(CenterResource.getActiveCenters())
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.centers = response
            if (StoreUtils.selectedLaboratoryConfiguration?.center && selectCenter) {
                this.centerSelected = StoreUtils.selectedLaboratoryConfiguration.center
            } else {
                this.centerSelected = response[0]
            }
        },
        onPopoverShow() {
            this.$refs.myPopover._toolpop.getTipElement().classList.add('selector-pop')
        },
        saveSearchState() {
            this.$store.commit('updateSearchState', this.$data)
        },
        searchEvent() {
            this.searched = true
            this.$emit('submitSearch', this.identifierSearch)
            const searchBarInput = document.getElementById('searchBarInput')
            searchBarInput.select()
            if (this.searchOptionSelected.id && this.searchOptionSelected.id === PATIENT_IDENTIFIER) {
                if (!this.identifierSearch && !this.patientNameSearch &&
                    !this.patientMiddlenameSearch && !this.patientSurname1Search &&
                    !this.patientSurmname2Search) {
                    this.searched = false
                    return
                }
                let patientSearchInformation = {
                    identifierSearch: this.identifierSearch.trim(),
                    patientNameSearch: this.patientNameSearch.trim(),
                    patientMiddlenameSearch: this.patientMiddlenameSearch.trim(),
                    patientSurname1Search: this.patientSurname1Search.trim(),
                    patientSurmname2Search: this.patientSurmname2Search.trim(),
                    center: this.patientOptionSelected.code === PATIENT_IDENTIFIER_CODES.NHC ? this.centerSelected?.code : null,
                    type: this.patientOptionSelected.code,
                    identifierName: this.patientOptionSelected.name
                }
                if (this.identifierSearch) {
                    const patientRegex = this.regex.find((reg) => reg.identifierType.code === this.patientOptionSelected.code)
                    const patientRegexObject = new RegExp('^(?:' + patientRegex.regex + ')$')
                    if (!patientRegexObject.test(this.identifierSearch.trim())) {
                        this.showErrorModalGlobal(this.$t('component.patient.searcher.error.validPatientIdentifier', { identifier: this.patientOptionSelected.name }))
                        return
                    }
                }
                this.saveSearchState()
                this.$emit('patientSearch', patientSearchInformation)
                return
            } else if (this.searchOptionSelected?.id === INSURANCE_NUMBER) {
                this.saveSearchState()
                this.$emit('insuranceNumberSearch', this.identifierSearch.trim())
                return
            }
            for (const regex of this.regex) {
                const regexObj = new RegExp('^(?:' + regex.regex + ')$')
                const searchInformation = this.identifierSearch.trim()
                if (regexObj.test(searchInformation.trim())) {
                    if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.CASE) {
                        this.saveSearchState()
                        this.$emit('studySearch', searchInformation)
                        return
                    } else if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.REQUEST) {
                        this.saveSearchState()
                        this.$emit('requestSearch', searchInformation)
                        return
                    } else if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.SUBREQUEST) {
                        this.saveSearchState()
                        this.$emit('subrequestSearch', searchInformation)
                        return
                    } else if (regex.identifierType.idtScope === IDENTIFIER_SCOPES.SAMPLE) {
                        this.saveSearchState()
                        this.$emit('sampleSearch', searchInformation)
                        return
                    } else {
                        this.showErrorModalGlobal(this.searchOptionSelected.errorMessage)
                    }
                }
            }
            this.showErrorModalGlobal(this.searchOptionSelected.errorMessage)
        },
        clearSearch() {
            this.searched = false
            this.search = ''
            this.$refs.searchBarInput.focus()
            this.selected = ''
            this.identifierSearch = ''
            this.patientSurname1Search = ''
            this.patientSurmname2Search = ''
            this.patientNameSearch = ''
            this.patientMiddlenameSearch = ''
            this.cleanSearchStateGlobalMixin()
            this.$emit('clearSearch')
        },
        clearState() {
            this.searched = false
        },
        focusInput() {
            if (this.searched) {
                this.$refs.searchBarInput.focus()
            }
        }
    }
}

</script>

<style lang="scss">
.local-searcher-clinical .id-model-select .multiselect__content-wrapper {
    width: auto;
    min-width: 100px;
}
.local-searcher-clinical .center-selection .multiselect__content-wrapper {
    width: auto;
    min-width: 200px;
}
.local-searcher-clinical .center-column {
    width: 230px;
}
.local-searcher-clinical .bar-width {
    max-width: 315px;
}
.local-searcher-clinical .search-box {
    min-height: 30px;
}
.local-searcher-clinical .search-box input {
    border: none;
    border-radius: 0;
    color: vt-color(primary);
}
.local-searcher-clinical .input-section {
    position: relative;
    width: 100%;
    color: vt-color(primary);
}
.local-searcher-clinical .input-section:before {
    content: '';
    width: 1px;
    height: 15px;
    background: vt-color(general-border);
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
}
.local-searcher-clinical .search-box .row .row .row .col:last-child .input-section:before {
    background: transparent;
}
/*.local-searcher-clinical .search-box div div:nth-last-child(3) .input-section:before {
    background: transparent;
}*/
.local-searcher-clinical .search-box .col {
    display: flex;
    align-items: center;
}
.local-searcher-clinical .select-section {
    position: relative;
    width: 100%;
}
.local-searcher-clinical .select-section .multiselect__tags {
    border: none;
    display: flex;
    align-items: center;
}
.local-searcher-clinical .select-section .multiselect__tags input {
    margin-bottom: 0 !important;
}
.local-searcher-clinical .select-section .multiselect__select {
    padding: 0;
    top: -2px;
}
.local-searcher-clinical .multiselect__placeholder {
    color: #495057;
}
.local-searcher-clinical .select-section.identifiers .multiselect__placeholder {
    color: vt-color(primary);
}
.local-searcher-clinical .multiselect {
    color: vt-color(primary);
}
.local-searcher-clinical .multiselect__single {
    margin-top: 3px;
}
.local-searcher-clinical .id-column {
    width: 80px;
}
/* -- Old --*/
@media only screen and (max-width: 900px) {
    .search-bar,
    .search-bar .search-input,
    .search-bar .search-input + div,
    .search-bar .search-input .general-search {
        width: 100%;
    }

    .search-bar .search-input .general-search .form-control {
       min-width: 100% !important;
    }
}

.patient-selection .line {
    width: 1px;
    height: 15px;
    background: vt-color(grid-general-border);
    margin: 0 10px;
}

.patient-selection .id-selector {
    width: 70px;
}

.patient-selection .id-selector .multiselect__tags {
    border: 0;
}

.patient-selection .id-selector .multiselect__single {
    margin-top: 3px;
}

.search-input.search-done {
    background: vt-color(primary);
    color: vt-color(white-light);
}

.search-input.search-done .multiselect__tags {
    background: transparent;
    color: vt-color(white-light);
    opacity: 1;
}

.search-input.search-done .multiselect__input {
    background: transparent;
    color: vt-color(white-light);
}

.search-input{
    border-radius: 0 5px 5px 0;
}

.search-input.search-done input,
.search-input.search-done input::placeholder {
    color: vt-color(white-light);
}

.search-input.search-done .button-section {
    background: vt-color(dark-primary);
}

.search-input.search-done .button-section i {
    color: vt-color(white-light);
}

.search-input .button-section {
    height: 100%;
    border-radius: 0 5px 5px 0;
    width: 40px;
}

.local-searcher-clinical .search-selector .multiselect__content-wrapper{
    min-width: 100%;
    width: auto !important;
    overflow: hidden;
    overflow-y: auto;
}

.local-searcher-clinical .search-selector .multiselect--small .multiselect__tags{
    border: 0;
    background: vt-color(search-bar-bg);
    display: flex;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
}
.local-searcher-clinical .search-selector .multiselect--small .multiselect__single{
    width: 20px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
}

.local-searcher-clinical .search-selector .multiselect--small .multiselect__single i{
    font-size: 15px;
}

.local-searcher-clinical .search-selector .multiselect--small .multiselect__element span{
    padding: 12px;
}

.local-searcher-clinical .search-selector .multiselect--small .multiselect__element i{
    font-size: 16px;
    width: 20px;
}

.search-bar {
    background: #FFF;
    border-radius: 5px !important;
    border: 0 !important;
    box-shadow: 0 1px 5px 0 #9c9c9c;
    height: 28px;
    display: inline-flex;
}

.local-searcher-clinical .search-selector {
    width: 60px;
    height: 100%;
    border-right: 2px solid vt-color(grid-general-border);
    padding-left: 2px;
}

.local-searcher-clinical .search-selector .entity {
    font-size: 16px;
}

.search-bar .search-input .form-control {
    border: 0;
    background: transparent;
}

.search-bar .search-input .general-search .form-control {
    min-width: 150px;
}

.search-bar .search-input .patient-search .form-control {
    min-width: 200px;
}

.search-bar .search-input .id-section {
    width: 90px;
}

.search-bar .search-input .name-section {
    width: 110px;
}

.radio-btns{
  display: flex;
  flex-direction: column;
}

.radio-box .form-group{
  margin-bottom: 0 !important;
}

.radio-btns .custom-radio{
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  margin: 0;
  padding: 5px 30px;
}

.vt-search-bar-done ::placeholder{
  color: #FFF !important;
  opacity: 1 !important;
}

.search-component .search-combo{
  max-width: 120px;
}

.search-width{
  max-width: 280px !important;
}

.search-component .search-combo .multiselect__tags{
  border-radius: 5px !important;
  border: 0 !important;
  box-shadow: 0 1px 5px 0 #9c9c9c;
  height: 28px;
}

.search-component .entity-selector .multiselect__tags{
  height: 28px;
}

.search-component .custom-select{
  background: none;
  background-color: white;
  border: 0;
  box-shadow: 0 1px 5px 0 #9c9c9c;
  border-radius: 5px;
}

.search-component .multiselect__content-wrapper{
  min-width: 100%;
  width: auto !important;
  overflow: hidden;
  overflow-y: auto;
}

.search-component .multiselect--small .multiselect__tags{
  border-radius: 5px;
  box-shadow: 0 1px 5px 0 vt-color(search-bar-box-shadow);
  background: vt-color(search-bar-bg);
  display: flex;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.search-component .multiselect--small .multiselect__select,
.search-bar .patient-selection .multiselect__select {
  align-items: center;
  width: 28px;
    height: 24px;
    padding-right: 2px;
    padding-left: 2px;
}

.search-bar .patient-selection .multiselect__select {
    top: 2px;
    transition: none;
}

.search-component .multiselect--small .multiselect__select::before,
.search-bar .patient-selection .multiselect__select::before {
  top: 12px;
}

.search-component .multiselect--small .multiselect__single{
  width: 20px;
  padding: 0;
  display: flex;
  align-items: center;
}

.search-component .multiselect--small .multiselect__single i{
  font-size: 18px;
}

.search-component .multiselect--small .multiselect__element span{
  padding: 12px;
}

.search-component .multiselect--small .multiselect__element i{
  font-size: 18px;
}

</style>

<style scoped lang="scss">

.search-component .fa-th-large{
  font-size: 13px;
}

.search-component .touch-screen{
  display: none;
}

.vt-search-bar {
  background-color: vt-color(search-bar-bg);
  height: 28px;
  border-radius: 5px;
  border: 0;
  box-shadow: 0 1px 5px 0 vt-color(search-bar-box-shadow);
  .input-group-prepend .input-group-text {
    border-radius: 14px;
    color: vt-color(search-bar-text);
    border: none;
    background-color: inherit;
    font-size:1.1rem;
    padding:0.7rem;
  }
  input {
    width: 150px;
    border: none;
    color: vt-color(search-bar-text);
    background-color: inherit;
    padding-top:0.4rem;
  }
  .icon-search {
    color: white;
    font-size:0.8rem;
  }
}

.vt-search-bar-done{
  background-color: vt-color(primary);
  color: #FFF;
}

.vt-search-bar-done .form-control{
  color: #FFF;
}

.vt-search-bar-done .search-button{
  width: 40px !important;
  background-color: vt-color(dark-primary);
}

.vt-search-bar-done .search-button i{
  color: #FFF;
}

.vt-search-bar-done .search-button:hover{
  background-color: vt-color(dark-primary, .2);
  color: #FFF;
}

.search-component .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle{
  background-color: #FFF;
}

.search-button-wrapper {
  display: flex;
  align-items: center;
}

.search-button {
  border-radius: 0 5px 5px 0;
  width: 30px;
  line-height: 1;
  color: inherit;
  background-color: vt-color(search-bar-bg);
  border:transparent;
  height:95%;
}

.search-button i{
  color: vt-color(primary);
  font-size: 14px;
}

.search-button:hover{
  background-color: #FFF;
}

.icon-search {
    color: white;
    font-size:1.1rem;
}

.options-button {
  border-radius: 0 5px 5px 0;
  width: 25px;
  line-height: 1;
  color: inherit;
  background-color: vt-color(search-bar-bg);
  border:transparent;
  height:95%;

}

.options-button i{
  color: vt-color(primary);
  font-size: 14px;
}

.options-button:hover{
  background-color: #FFF;
}

.input-group-append{
  z-index: 3;
}

@media (max-width: 1370px){
    .vt-search-bar {
  .input-group-prepend .input-group-text {
    font-size:0.85rem;
    padding:0.6rem;
  }
  input {
    font-size:0.85rem;
    padding-top:0.4rem;
  }
  .icon-search {
    color: white;
    font-size:0.8rem;
}
}

@media (max-width: 1024px){
  .search-component .search-combo{
    max-width: 100%;
}
}

}

</style>
